<template>
  <ReportOvertimePopover
    v-if="hasOvertime"
    class="overtime-popover"
    :overtime="overtime"
    :icon-classes="iconClasses"
    :popover-container-classes="containerClasses"
    :show-financial="showFinancial"
    :currency="organization.currency"
  />
</template>

<script>
import { some, sumBy, find } from 'lodash-es';
import ReportOvertimePopover from '~/components/reports/ReportOvertimePopover.vue';

export default {
  name: 'TimeEntriesOvertimePopover',
  components: {
    ReportOvertimePopover,
  },
  props: {
    timeEntries: { type: Array },
    iconClasses: { type: String },
    containerClasses: { type: String, default: '' },
    organization: { type: Object, required: true },
    showFinancial: { type: Boolean, required: true },
  },
  computed: {
    overtime() {
      return [{ overtime: this.totalOvertime, overtimeRate: this.overtimeRate }];
    },
    hasOvertime() {
      return some(this.timeEntries, (timeEntry) => timeEntry.overtime && timeEntry.overtime.tracked > 0);
    },
    totalOvertime() {
      return sumBy(this.timeEntries, 'overtime.tracked');
    },
    overtimeRate() {
      const entryWithOvertime = find(
        this.timeEntries,
        (timeEntry) => timeEntry.overtime && timeEntry.overtime.tracked > 0 && timeEntry.overtime.pay_rate,
      );

      if (entryWithOvertime) {
        return Number(entryWithOvertime.overtime.pay_rate);
      }

      return Number(0);
    },
  },
};
</script>
